'use client';

import { PreCheckoutPage } from "@/features/PreCheckoutPage";
import classNames from "classnames";
import { useEffect, useState } from "react";

export const PreCheckout = ({
	data,
	onAnswer,
	isTransitioning,
	direction,
	formSubmit,
	isDisabled = false,
	trialVariation = false,
	promotionAmountOff = 0,
	clientSecret,
	pricePerMonth,
	customerUpdate,
	userEmail,
	onEmailChange,
}) => {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		// Start with opacity 0, then fade in after a brief delay
		const timer = setTimeout(() => {
			setIsVisible(true);
		}, 50);

		return () => clearTimeout(timer);
	}, []);

	console.log('PreCheckout', {
		trialVariation,
		promotionAmountOff,
		pricePerMonth,
	});

	return (
		<div
			className={classNames(
				"transition-opacity duration-500",
				{
					"opacity-0": isTransitioning || !isVisible,
					"opacity-100": !isTransitioning && isVisible,
				}
			)}>
			<PreCheckoutPage
				trialVariation={trialVariation}
				promotionAmountOff={promotionAmountOff}
				formSubmit={formSubmit}
				isDisabled={isDisabled}
				clientSecret={clientSecret}
				pricePerMonth={pricePerMonth}
				customerUpdate={customerUpdate}
				userEmail={userEmail}
				onEmailChange={onEmailChange}
			/>
		</div>
	);
};
